import React from "react";
import "../avancus-ins.css";

const AvancusInstitucional = () => {
  return (  
    <section className="avancus-institutional">

  <div className="avancus-institutional__container">

    <div className="avancus-institutional__left">
      <span className="avancus-institutional__badge">
        Distribuidor Oficial
      </span>

      <h2>
        Avancus Argentina
      </h2>

      <p>
        Somos distribuidores oficiales de Avancus en Argentina.
        Descubrí la línea completa de calzado diseñada para competencia,
        desarrollada para atletas que entrenan y compiten en serio.
      </p>

      <a
        href="https://liftingshoes.com.ar"
        target="_blank"
        rel="noopener noreferrer"
        className="avancus-institutional__btn"
      >
        Ir a la tienda oficial →
      </a>
    </div>

    <div className="avancus-institutional__right">
      <img
        src="../Banners/ava-banner.png" 
        alt="Avancus Argentina"
      />
    </div>

  </div>

</section>

    
  );
};

export default AvancusInstitucional;